package ui.external.materialui

object ButtonVariant {
    const val contained = "contained"
    const val outlined = "outlined"
}
